import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { splashPlatformGuard } from './shared/guards/splash-platform.guard';

const routes: Routes = [
  {
    path: 'splash',
    canActivate: [splashPlatformGuard],
    loadComponent: () => import('./pages/unauthenticated/splash/splash.page').then((m) => m.SplashPage),
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/unauthenticated/unauthenticated.module').then((m) => m.UnauthenticatedModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/authenticated/authenticated.module').then((m) => m.AuthenticatedModule),
  },
  { path: '**', redirectTo: '' },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
